import {
  ActionIcon,
  Badge,
  Box,
  Button,
  Flex,
  Grid,
  Group,
  Input,
  Menu,
  MultiSelect,
  MultiSelectProps,
  ScrollArea,
  Select,
  Text,
  TextInput,
  Title,
  Tooltip,
  rem,
} from "@mantine/core";
import {
  IconBarcode,
  IconCaretDown,
  IconCheck,
  IconEyeSearch,
  IconFileBarcode,
  IconFileExport,
  IconPhone,
  IconSearch,
  IconUser,
  IconX,
} from "@tabler/icons-react";
import {
  MRT_ColumnDef,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MantineReactTable,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import {
  repositoryDelivery,
  repositoryMdm,
  repositoryPos,
} from "../../../_base/_const/_constVar";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import { formatDateTransfer } from "../../../common/FormatDate/FormatDate";
import { BASE_API_MDM } from "../../../config";
import { _localization } from "../../../config/location";
import { MessageResponse } from "../../../model/MessageResponse";
import { SelectListItemModel } from "../../../model/SelectListItem";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { useDebouncedValue } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import DetailChildSerial from "./DetailChildSerial";

interface DatacustomerCodeModel {
  branchId: number | null;
  loaiCt: string | null;
  soCt: string | null;
  ngayCt: string | null;
  serial: string | null;
  serialThayThe: string | null;
  custId: number;
  itemId: string | null;
  maVt: string | null;
  tenVt: string | null;
  maKh: string;
  tenKh: string | null;
  soDt: string | null;
  dienGiai: string | null;
  thoiHanBhNcc: string | null;
  soCtGoc: string | null;
  text: string;
  value: string;
}

const BarcodeHistory = () => {
  const [searchParams] = useSearchParams();
  const initialSerial = (searchParams.get("serial") || "").trim();
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [isRefetching, setIsRefetching] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isCallFirst, setIsCallFirst] = useState<boolean>(false);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [height, setHeight] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [data, setData] = useState<Department[]>([]);
  const [rowCount, setRowCount] = useState(0);
  const [dataCustomer, setDataCustomer] = useState<SelectListItemModel[]>([]);
  const [dataItemCode, setDataItemCode] = useState<SelectListItemModel[]>([]);
  const handleChangeSearchValue = (value: string[] | null, key: string) => {
    setSearch((prevData) => ({
      ...prevData,
      [key]: value ? value : [],
    }));
  };
  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        header: "STT",
        accessorKey: "STT",
        enableColumnActions: false,
        Cell: ({ row }) => <>{row?.index + 1}</>,
        size: 100,
      },
      {
        accessorKey: "soCtGoc",
        enableColumnActions: false,
        header: "Chứng từ gốc",

        Cell: ({ renderedCellValue, cell }) => (
          <Badge
            radius="sm"
            variant="dot"
            size="lg"
            color={renderedCellValue === null ? "red" : "#21d01b"}
          >
            {renderedCellValue === null ? "Không xác định" : renderedCellValue}
          </Badge>
        ),
        size: 220,
      },
      {
        accessorKey: "soCt",
        enableColumnActions: false,
        header: "Số chứng từ",
        size: 200,
        Cell: ({ renderedCellValue, cell }) => (
          <Badge
            radius="sm"
            variant="dot"
            size="lg"
            color={renderedCellValue === null ? "red" : "#21d01b"}
          >
            {renderedCellValue === null ? null : renderedCellValue}
          </Badge>
        ),
      },
      {
        accessorKey: "branchCode",
        enableColumnActions: false,
        header: "Mã chi nhánh",
        Cell: ({ row, renderedCellValue }) =>
          renderedCellValue === null ? null : (
            <>
              <Badge variant="light" color={"violet"}>
                {renderedCellValue}
              </Badge>
            </>
          ),
      },
      {
        accessorKey: "branchName",
        enableColumnActions: false,
        header: "Tên chi nhánh",
      },
      {
        accessorKey: "inventoryCode",
        enableColumnActions: false,
        header: "Mã kho",
        Cell: ({ row, renderedCellValue }) =>
          renderedCellValue === null ? null : (
            <>
              <Badge variant="light" color={"blue"}>
                {renderedCellValue}
              </Badge>
            </>
          ),
      },
      {
        accessorKey: "inventoryName",
        enableColumnActions: false,
        header: "Tên kho",
      },
      {
        accessorKey: "maNcc",
        header: "Mã NCC",
        enableColumnActions: false,
        Cell: ({ row, renderedCellValue }) =>
          renderedCellValue === null ? null : (
            <>
              <Badge variant="light" color={"blue"}>
                {renderedCellValue}
              </Badge>
            </>
          ),
      },
      {
        accessorKey: "tenNcc",
        header: "Tên NCC",
        enableColumnActions: false,
      },
      {
        accessorKey: "loaiCt",
        enableColumnActions: false,
        header: "Loại chứng từ",
      },
      {
        accessorKey: "ngayCt",
        enableColumnActions: false,
        header: "Ngày chứng từ",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "serial",
        enableColumnActions: false,
        header: "Mã vạch",
        Cell: ({ renderedCellValue, cell, row }) => (
          <Box
            style={{
              borderRadius: "30px",
              backgroundColor: "#E8F3FC",
              padding: "4px",
            }}
          >
            <Text variant="light" p="4px 8px" size="xs" color="blue" fw="bold">
              {renderedCellValue ?? ""}
            </Text>
          </Box>
        ),
      },
      {
        accessorKey: "serialThayThe",
        enableColumnActions: false,
        header: "Mã vạch thay thế",
        Cell: ({ renderedCellValue, cell, row }) =>
          renderedCellValue ? (
            <Box
              style={{
                borderRadius: "30px",
                backgroundColor: "#E8F3FC",
                padding: "4px",
              }}
            >
              <Text variant="light" p="4px 8px" size="xs" c="blue" fw="bold">
                {renderedCellValue ?? ""}
              </Text>
            </Box>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "maVt",
        enableColumnActions: false,
        header: "Mã vật tư",
        Cell: ({ renderedCellValue, cell, row }) =>
          renderedCellValue ? (
            <Box
              style={{
                borderRadius: "30px",
                backgroundColor: "#E8F3FC",
                padding: "4px",
              }}
            >
              <Text
                variant="light"
                p="4px 8px"
                size="xs"
                color="blue"
                fw="bold"
              >
                {renderedCellValue}
              </Text>
            </Box>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "tenVt",
        enableColumnActions: false,
        header: "Tên vật tư",
        size: 700,
      },
      {
        accessorKey: "maKh",
        enableColumnActions: false,
        header: "Mã khách hàng",
        Cell: ({ renderedCellValue, cell, row }) =>
          renderedCellValue ? (
            <Box
              style={{
                borderRadius: "30px",
                backgroundColor: "#E8F3FC",
                padding: "4px",
              }}
            >
              <Text variant="light" p="4px 8px" size="xs" c="blue" fw="bold">
                {renderedCellValue ?? ""}
              </Text>
            </Box>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "tenKh",
        enableColumnActions: false,
        header: "Tên khách hàng",
      },
      {
        accessorKey: "soDt",
        enableColumnActions: false,
        header: "Số điện thoại",
      },
      {
        accessorKey: "dienGiai",
        enableColumnActions: false,
        header: "Diễn giải",
      },
      {
        accessorKey: "hanBhNcc",
        enableColumnActions: false,
        header: "Hạn bảo hành NCC",
        Cell: ({ renderedCellValue }) => (
          <Text fw={500} size="12.5px">
            {renderedCellValue ? `${renderedCellValue} tháng` : ""}
          </Text>
        ),
      },
      {
        accessorKey: "hanBhHnc",
        enableColumnActions: false,
        header: "Hạn bảo hành HACOM",
        Cell: ({ renderedCellValue }) => (
          <Text fw={500} size="12.5px">
            {renderedCellValue ? `${renderedCellValue} tháng` : ""}
          </Text>
        ),
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        enableSorting: false,
        size: 95,
        Cell: ({ row }) => (
          <Flex gap={"sm"} align={"center"}>
            <Tooltip label="Xem danh sách serial con">
              <ActionIcon
                variant="light"
                color="blue"
                onClick={() =>
                  modalSearchChildSerialToLine(
                    row.original.serialThayThe &&
                      String(row.original.serialThayThe).length > 0
                      ? row.original.serialThayThe
                      : row.original.serial,
                  )
                }
              >
                <IconEyeSearch size={18} />
              </ActionIcon>
            </Tooltip>
          </Flex>
        ),
      },
    ],
    [],
  );

  const handleChangeSearch = (value: string, key: string) => {
    setSearch((prevData) => ({
      ...prevData,
      [key]: value ? value : "",
    }));
  };

  const [search, setSearch] = useState({
    keySearch: "",
    itemCode: [],
    serial: initialSerial,
    maKh: "",
    maVt: "",
    soDienThoai: "",
  });
  const [searchMaKh, setSearchMaKh] = useState<string>("");
  const [debouncedMaKh] = useDebouncedValue(searchMaKh, 500);

  const menuCustomer = useMemo(() => {
    if (dataCustomer.length === 0) {
      return (
        <Menu.Item>
          <Flex justify="center">
            <Text size="sm">Không tìm thấy dữ liệu !</Text>
          </Flex>
        </Menu.Item>
      );
    }

    return dataCustomer.map((item, index) => (
      <Menu.Item
        key={`${item.value}-${index}`}
        onClick={() => {
          if (search.maKh !== item.value) {
            setSearchMaKh(item.label);
            handleChangeSearch(item.value, "maKh");
          } else {
            setSearchMaKh("");
            handleChangeSearch("", "maKh");
          }
        }}
      >
        <Flex align="center" gap="xs">
          {search.maKh === item.value && (
            <IconCheck size={14} color="#808080" />
          )}
          <Text size="sm" truncate="end">
            {item.label}
          </Text>
        </Flex>
      </Menu.Item>
    ));
  }, [dataCustomer, searchMaKh, search.maKh]);

  const fetchData = async () => {
    if (
      search.serial.length === 0 &&
      search.soDienThoai.length === 0 &&
      search.keySearch.length < 3
    ) {
      NotificationExtension.Fails(
        "Vui lòng nhập mã serial, số điện thoại khách hàng hoặc ít nhất 3 kí tự từ khóa trước khi tìm kiếm !",
      );
    } else {
      setIsLoading(true);
      setIsRefetching(true);
      setIsError(false);

      let url = `?Skip=${pagination?.pageIndex * pagination?.pageSize}&Take=${
        pagination.pageSize
      }`;

      if (search.keySearch) {
        url += `&KeySearch=${search.keySearch?.trim()?.toLowerCase()}`;
      }
      if (search.serial) {
        url += `&Serial=${search.serial?.trim()}`;
      }
      if (search.maKh) {
        url += `&MaKh=${search.maKh}`;
      }
      if (search.itemCode.length > 0) {
        url += `&MaVt=${search.itemCode}`;
      }
      if (search.soDienThoai) {
        url += `&SoDt=${search.soDienThoai.trim()}`;
      }
      try {
        const response = await repositoryMdm.get(
          `api/v1/VSerialHistory/get-list${url}`,
        );

        if (response && response.success) {
          let result = response.data.lists;
          setData(result);
          setRowCount(response.totalCount);
          table.resetRowSelection();
          setIsCallFirst(true);
        }
      } catch (error) {
        setData([]);
        setIsError(true);
        console.error(error);
        return;
      } finally {
        setIsLoading(false);
        setIsRefetching(false);
      }
    }
  };

  const exportDataExcel = async () => {
    if (
      search.serial.length === 0 &&
      search.soDienThoai.length === 0 &&
      search.keySearch.length < 3
    ) {
      NotificationExtension.Fails(
        "Vui lòng nhập mã serial, số điện thoại khách hàng hoặc ít nhất 3 kí tự từ khóa trước khi tìm kiếm !",
      );
    } else {
      // const baseUrl = `https://apis-pos-dev.hacom.vn/api-mdm/api/v1/ExportExcel/export-lich-su-ma-vach`;
      // const fileName = "bao_cao_lich_su_ma_vach.xlsx";
      // exportDataToExcel(baseUrl, fileName);
      const url = `/api/v1/ExportExcel/export-lich-su-ma-vach`;
      const _url = BASE_API_MDM + url;
      const token = localStorage.getItem("token");

      const response = await fetch(_url, {
        method: "GET",
        headers: {
          "Content-Type": "application/vnd.ms-excel",
          Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to download file");
      }
      const blob = await response.blob();
      const urlss = window.URL.createObjectURL(blob);
      const _name = new Date().toISOString().slice(0, 10);
      let filename = "bao_cao_lich_su_ma_vach.xlsx";
      const link = document.createElement("a");
      link.href = urlss;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    }
  };

  const fetchDataCustomer = async () => {
    let url = `/api/v1/TblDmCustomer/get-list?Skip=0&Take=20`;

    if (debouncedMaKh.length > 0 && search.maKh.length === 0) {
      url += `&KeySearch=${debouncedMaKh}`;
    }

    if (search.maKh.length > 0) {
      url += `&CusCode=${search.maKh}`;
    }

    const res = await repositoryPos.get<MessageResponse<any>>(url);

    if (res && res.success) {
      const result = res.data
        ?.filter((item: any) => item.code && item.name)
        ?.map((item: any) => ({
          label: `${item.code} - ${item.name}`,
          value: item.code?.toString(),
        }));
      setDataCustomer(result);
    }
  };

  const DataItemCode = async (keySearch: string) => {
    try {
      let url = "";
      if (keySearch && keySearch.length > 0) {
        url += `&ItemCodes=${keySearch}`;
      }
      // const response = await repositoryDelivery.get(
      //   `api/v1/TblInventorySerialOnhand/get-list-item-by-inv?Skip=0&Take=50` +
      //     url
      // );
      const response = await repositoryPos.get(
        `/api/v1/TblItem/get-select?Key=${keySearch}&Page=30`,
      );
      if (response && response.success) {
        // const transformedData = response.data
        //   ?.filter((i: any) => i.maSp && i.tenSp)
        //   .map((branch: any) => ({
        //     value: branch.maSp,
        //     label: branch.maSp + " - " + branch.tenSp,
        //   }));
        const transformedData = response.data
          ?.filter((i: any) => i.value && i.text)
          .map((branch: any) => ({
            value: branch.value,
            label: branch.text,
          }));
        const uniqueData = Array.from(
          new Set(transformedData.map((item: any) => item.value)),
        ).map((value) =>
          transformedData.find((item: any) => item.value === value),
        );
        setDataItemCode(uniqueData);
      }
    } catch (error) {
      console.error(error);
      return;
    }
  };

  const modalSearchChildSerialToLine = async (serial: string) => {
    modals.openConfirmModal({
      title: <Title order={5}>Danh sách serial con - {serial}</Title>,
      size: "auto",
      children: <DetailChildSerial serial={serial} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: true,

    enableColumnFilters: false,
    enableSorting: true,
    enableColumnActions: true,
    // manualPagination: true,
    rowCount,
    state: {
      // columnFilters,
      // globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      rowSelection,
    },
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    onPaginationChange: setPagination,
    positionToolbarAlertBanner: "bottom",
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["STT", "soCt"],
        right: ["action"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTopToolbarProps: {
      style: {
        // borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        // marginTop: "10px",
        display: "none",
      },
    },
    localization: _localization,
    getRowId: (row) => row.departmentId,
    mantineTableContainerProps: {
      style: { maxHeight: height + 30, minHeight: height + 30 },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: "550",
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    mantineToolbarAlertBannerProps: false
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "xl",
      size: "lg",
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    mantineTableBodyRowProps: ({ row }) => ({
      onClick: row.getToggleSelectedHandler(),
      sx: { cursor: "pointer" },
    }),
  });
  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (175 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (initialSerial) {
      setIsCallFirst(true);
    }
  }, [initialSerial]);

  useEffect(() => {
    if (isCallFirst) {
      fetchData();
    }
  }, [pagination, isCallFirst]);

  useEffect(() => {
    fetchDataCustomer();
  }, [debouncedMaKh]);

  const renderMultiSelectOptionVT: MultiSelectProps["renderOption"] = ({
    option,
  }) => (
    <Group gap="sm">
      <Text>{dataItemCode.find((x) => x.value === option.value)?.label}</Text>
    </Group>
  );

  //#region new

  //#endregion
  return (
    <>
      <div ref={headerRef}>
        <Group align="center" justify="space-between">
          <_breadcrumb></_breadcrumb>
          <Menu shadow="md" width={200}>
            <Menu.Target>
              <Button
                // size="xs"
                rightSection={
                  <IconCaretDown style={{ width: rem(14), height: rem(14) }} />
                }
              >
                Chức năng
              </Button>
            </Menu.Target>

            <Menu.Dropdown>
              <Menu.Label>Application</Menu.Label>
              <Menu.Item
                leftSection={
                  <IconFileExport style={{ width: rem(14), height: rem(14) }} />
                }
                onClick={() => exportDataExcel()}
              >
                Export Excel
              </Menu.Item>
              <Menu.Item
                leftSection={
                  <IconX style={{ width: rem(14), height: rem(14) }} />
                }
              >
                Đóng
              </Menu.Item>
            </Menu.Dropdown>
          </Menu>
        </Group>

        <Grid>
          <Grid.Col span={{ base: 12, xs: 6, md: 4, lg: 2 }}>
            <Input
              placeholder="Nhập từ khóa "
              type="text"
              leftSection={<IconSearch size={"20"} color="#15aabf" />}
              // key={form.key("keySearch")}
              // {...form.getInputProps("keySearch")}
              onChange={(e) => {
                handleChangeSearch(e.target.value ?? "", "keySearch");
              }}
              onKeyDown={async (e) => {
                if (e.key === "Enter") {
                  await fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 6, md: 4, lg: 2 }}>
            <Input
              placeholder="Số điện thoại"
              type="text"
              leftSection={<IconPhone size={"20"} color="#15aabf" />}
              onChange={(e) => {
                handleChangeSearch(e.target.value ?? "", "soDienThoai");
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 6, md: 4, lg: 2 }}>
            <Input
              placeholder="Nhập serial"
              type="text"
              value={search.serial}
              leftSection={<IconFileBarcode size={"20"} color="#15aabf" />}
              onChange={(e) => {
                handleChangeSearch(e.target.value ?? "", "serial");
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 6, md: 4, lg: 2 }}>
            <Box w={"100%"} style={{ position: "relative" }}>
              <Menu
                width="target"
                position="bottom"
                offset={5}
                keepMounted
                closeOnItemClick={false}
              >
                <Menu.Target>
                  <TextInput
                    placeholder="Nhập mã khách hàng hoặc tên khách hàng"
                    leftSection={<IconUser size={20} color="#15aabf" />}
                    rightSectionPointerEvents="all"
                    rightSection={
                      <IconX
                        size={20}
                        color="#15aabf"
                        onClick={() => {
                          handleChangeSearch("", "maKh");
                          setSearchMaKh("");
                        }}
                        style={{
                          display: searchMaKh.length > 0 ? undefined : "none",
                          cursor: "pointer",
                        }}
                      />
                    }
                    value={searchMaKh}
                    onChange={(e) => {
                      setSearchMaKh(e.currentTarget.value);
                    }}
                    style={{ width: "100%" }}
                  />
                </Menu.Target>
                <Menu.Dropdown>
                  <ScrollArea
                    h={
                      dataCustomer.length <= 1
                        ? 32
                        : dataCustomer.length === 2
                          ? 64
                          : dataCustomer.length === 3
                            ? 96
                            : dataCustomer.length === 4
                              ? 128
                              : dataCustomer.length === 5
                                ? 160
                                : dataCustomer.length === 6
                                  ? 192
                                  : 225
                    }
                    offsetScrollbars
                    scrollbars="y"
                  >
                    {menuCustomer}
                  </ScrollArea>
                </Menu.Dropdown>
              </Menu>
            </Box>
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 6, md: 4, lg: 2 }}>
            <MultiSelect
              size="sm"
              placeholder="Mã vật tư"
              clearable
              searchable
              data={dataItemCode.map((x) => x.value)} // Hiển thị kết quả từ API
              value={search.itemCode}
              renderOption={renderMultiSelectOptionVT}
              leftSection={<IconBarcode size={20} color="#15aabf" />}
              onSearchChange={(value) => {
                if (value.length >= 3) {
                  DataItemCode(value); // Gọi API với từ khóa tìm kiếm
                }
              }}
              onChange={(value) => {
                handleChangeSearchValue(value, "itemCode");
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 6, md: 4, lg: 2 }}>
            <Button
              color="blue"
              variant="outline"
              onClick={async () => {
                await fetchData();
              }}
            >
              Tìm kiếm
            </Button>
          </Grid.Col>
        </Grid>
      </div>
      <Box mt={10}>
        <MantineReactTable table={table} />
      </Box>
    </>
  );
};

export default BarcodeHistory;
type Department = {
  departmentId: number;
  name: string;
  description: string | null;
  active: boolean;
  deparmentCode: string;
  creationDate: string | null;
  createdBy: string | null;
  lastUpdateDate: string | null;
  lastUpdatedBy: string | null;
  address: string;
  branchId: number;
};
